import {MappedComponentProperties} from "@adobe/aem-react-editable-components";
import React from "react";
import extractModelId from "../../utils/extract-model-id";
import {StickyCta, StickyCtaData} from "../../ui.lib/components/shared/stickyCta";
import {useAppData} from "../../utils/AppContext";
import ErrorBoundary from "../../utils/ErrorBoundary";


const StickyCtaComponent = (props: MappedComponentProperties & { "data": any }) => {
    console.log('StickyCtaComponent---data', props);
    const {data} = props;

    const {fallbackContactPhoneNumber, fallbackContactPhoneNumberTitle, Campaign_ID__c} = useAppData();

    const CMS_CTA_DATA: StickyCtaData = {
        id: data?.id,
        phoneNo: fallbackContactPhoneNumber ?? data?.phoneNo,
        phoneNoTitle: fallbackContactPhoneNumberTitle ?? data?.phoneNoTitle,
        hidePhoneNo: data?.driftChatHidePhoneNumber,
        sFDCLastCampaignID: Campaign_ID__c ?? "",
        driftChat: data?.driftChat,
        driftChatId: data?.driftChatId,
        driftChatIcon: data?.driftChatIcon,
        driftChatIconAltText: data?.driftChatIconAltText,
        enableSalesforceChat: data?.enableSalesforceChat
    }
    return <div id={extractModelId(props.cqPath)}>
        <ErrorBoundary>
            <StickyCta data={CMS_CTA_DATA}/>
        </ErrorBoundary>

    </div>
};

export default StickyCtaComponent;
